import React from 'react';

const HamburgerMenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#3FB0E8">
        <path
          d="M24 16v2H0v-2h24zm0-8v2H0V8h24zm0-8v2H0V0h24z"
          transform="translate(0 3)"
        />
      </g>
    </g>
  </svg>
);
export default HamburgerMenuIcon;
